import "./ImagesManager.scss";

import { Box, Button, Grid } from "@material-ui/core";
import { CameraAlt } from "@material-ui/icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useLightbox } from "simple-react-lightbox";

import NoImageAvailable from "../../assets/images/no-image-available.jpg";
import { File } from "../../backend/generated/file-model";
import { CreateSaleManageable, SaleManageable } from "../../store/sale/types";
import Gallery from "../Gallery";
import { AcceptedFileType } from "../input/elements/FileUpload";
import { SaleField, SaleInputTypeKey } from "../input/fields";
import { SubformProps } from "../SubformProps";

export interface ImagesManagerProps extends SubformProps<CreateSaleManageable | SaleManageable> {
  id: SaleInputTypeKey;
  className?: string;
  onFilesSelected?: (value: Array<AcceptedFileType>) => void;
  onUploadEnded?: (value: Array<AcceptedFileType>) => void;
}

export function ImagesManager(props: ImagesManagerProps) {
  // Props
  const {
    id,
    values,
    setFieldValue,
    className,
  } = props;

  // Hooks
  const { openLightbox } = useLightbox();
  const { t } = useTranslation();

  // Options
  const images = values?.[id] as Array<File> || [];

  const elements = useMemo(
    () => {
      let result: Array<any> = images.map((
        file: File, index: number
      ) =>
        ({
          src: file.url,
          alt: "Sample" + index,
          hidden: false,
          className: "cover-image",
        }))
        || [];

      if (result.length === 0) {
        result = [
          {
            src: NoImageAvailable,
            alt: "NoImage",
            hidden: false,
            className: "cover-image",
          },
        ];
      }

      return result;
    },
    [images]
  );

  return (
    <>
      <Gallery elements={elements} className="image-stream" />

      <Box className={className}>
        <Grid container spacing={2}>
          {setFieldValue &&
          <Grid item xs={12}>
            <SaleField
              {...props}
            />
          </Grid>
          }

          {elements[0].src !== NoImageAvailable &&
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              className="primary"
              startIcon={<CameraAlt />}
              onClick={() => openLightbox(elements[0].src)}
            >
              {t("View photos")}
            </Button>
          </Grid>
          }
        </Grid>
      </Box>
    </>
  );
}